<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <h5>
          <b>Passo 1:</b> Selecione as
          <b>Empresas</b>
        </h5>
        <div class="row">
          <div class="col-md-6">
            <button
              class="btn btn-success btn-block mb-2"
              @click="
                moveAll(
                  users_selected.companies_notselected_all,
                  'companies',
                  'add'
                )
              "
            >
              <!-- <span class="badge badge-light">{{
                users_selected.companies_notselected.data.length
              }}</span> -->
              Mover todas as páginas >>
            </button>
            <button
              class="btn btn-success btn-block mb-2"
              @click="
                moveAll(
                  users_selected.companies_notselected.data,
                  'companies',
                  'add'
                )
              "
            >
              <span class="badge badge-light">{{
                users_selected.companies_notselected.data.length
              }}</span>
              Mover todas >>
            </button>
            <div class="input-group mb-2">
              <input
                type="text"
                class="form-control"
                v-model="filter.companies_search"
                placeholder="Procurar..."
                v-on:keyup.enter="getUsers()"
              />
              <div class="input-group-append">
                <button
                  class="btn btn-outline-secondary"
                  type="button"
                  @click="getUsers()"
                >
                  <i class="fa fa-search"></i>
                </button>
              </div>
            </div>
            <ul class="list-group entity-filter-selection">
              <li
                class="list-group-item"
                v-for="company in users_selected.companies_notselected.data"
                :key="company.id"
                @click="itemSelected(company.id, 'companies', 'selected')"
              >
                {{ company.fantasy_name }}
              </li>
            </ul>
            <paginate
              @click.native="getUsers"
              v-model="pages['companies_selected']"
              :page-count="users_selected.companies_notselected.last_page"
              :prev-text="'Anterior'"
              :next-text="'Próximo'"
              :container-class="'vue-pagination'"
            >
            </paginate>
          </div>
          <div class="col-md-6">
            <button
              class="btn btn-success btn-block mb-2"
              @click="
                removeAll(
                  users_selected.companies_selected_all,
                  'companies',
                  'remove'
                )
              "
            >
              << Remover todas as páginas
            </button>
            <button
              class="btn btn-success btn-block mb-2"
              @click="
                removeAll(
                  users_selected.companies_selected.data,
                  'companies',
                  'remove'
                )
              "
            >
              << Mover todas
              <span class="badge badge-light">{{
                users_selected.companies_selected.data.length
              }}</span>
            </button>
            <input
              type="text"
              placeholder="Procurar..."
              class="form-control mb-2"
              v-model="filter.companies_selected_search"
              v-on:keyup.enter="getUsers()"
            />

            <ul class="list-group entity-filter-selection">
              <li
                class="list-group-item"
                v-for="selectedCompany in users_selected.companies_selected
                  .data"
                :key="selectedCompany.id"
                @click="
                  removeItemSelected(
                    selectedCompany.id,
                    'companies',
                    'selected'
                  )
                "
              >
                {{ selectedCompany.fantasy_name }}
              </li>
            </ul>
            <paginate
              @click.native="getUsers"
              v-model="pages['companies_notselected']"
              :page-count="users_selected.companies_selected.last_page"
              :prev-text="'Anterior'"
              :next-text="'Próximo'"
              :container-class="'vue-pagination'"
            >
            </paginate>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <hr class="mt-5" />
        <h5>
          <b>Passo 2:</b> Selecione as
          <b>Unidades</b>
        </h5>
        <div class="row">
          <div class="col-md-6">
            <button
              class="btn btn-success btn-block mb-2"
              @click="
                moveAll(
                  users_selected.branchs_notselected_all,
                  'branches',
                  'add'
                )
              "
            >
              <!-- <span class="badge badge-light">{{
                users_selected.companies_notselected.data.length
              }}</span> -->
              Mover todas as páginas >>
            </button>
            <button
              class="btn btn-success btn-block mb-2"
              @click="
                moveAll(
                  users_selected.branchs_notselected.data,
                  'branches',
                  'add'
                )
              "
            >
              <span class="badge badge-light">{{
                users_selected.branchs_notselected.data.length
              }}</span>
              Mover todas >>
            </button>
            <div class="input-group mb-2">
              <input
                type="text"
                class="form-control"
                v-model="filter.branches_search"
                placeholder="Procurar..."
                v-on:keyup.enter="getUsers()"
              />
              <div class="input-group-append">
                <button
                  class="btn btn-outline-secondary"
                  type="button"
                  @click="getUsers"
                >
                  <i class="fa fa-search"></i>
                </button>
              </div>
            </div>
            <ul class="list-group entity-filter-selection">
              <li
                class="list-group-item"
                v-for="branch in users_selected.branchs_notselected.data"
                :key="branch.id"
                @click="itemSelected(branch.id, 'branches', 'selected')"
              >
                {{ branch.name }}
              </li>
            </ul>
            <paginate
              @click.native="getUsers"
              v-model="pages['branches']"
              :page-count="users_selected.branchs_notselected.last_page"
              :prev-text="'Anterior'"
              :next-text="'Próximo'"
              :container-class="'vue-pagination'"
            >
            </paginate>
          </div>
          <div class="col-md-6">
            <button
              class="btn btn-success btn-block mb-2"
              @click="removeAllFull('branches')"
            >
              << Remover todas as páginas
            </button>
            <button
              class="btn btn-success btn-block mb-2"
              @click="removeAll('selectedBranches', 'branches', 'branches')"
            >
              << Mover todas
              <span class="badge badge-light">{{
                users_selected.branchs_selected.data.length
              }}</span>
            </button>
            <input
              type="text"
              placeholder="Procurar..."
              class="form-control mb-2"
              v-model="filter.branches_selected_search"
              v-on:keyup.enter="getUsers()"
            />
            <ul class="list-group entity-filter-selection">
              <li
                class="list-group-item"
                v-for="selectedBranch in users_selected.branchs_selected.data"
                :key="selectedBranch.id"
                @click="
                  removeItemSelected(selectedBranch.id, 'branches', 'selected')
                "
              >
                {{ selectedBranch.name }}
              </li>
            </ul>
            <paginate
              @click.native="getUsers"
              v-model="pages['branches']"
              :page-count="users_selected.branchs_selected.last_page"
              :prev-text="'Anterior'"
              :next-text="'Próximo'"
              :container-class="'vue-pagination'"
            >
            </paginate>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <hr class="mt-5" />
        <h5>
          <b>Passo 3:</b> Selecione os
          <b>Departamentos</b>
        </h5>
        <div class="row">
          <div class="col-md-6">
            <button
              class="btn btn-success btn-block mb-2"
              @click="
                moveAll(
                  users_selected.sectors_notselected_all,
                  'sectors',
                  'selectedSectors'
                )
              "
            >
              Mover todas as páginas >>
            </button>
            <button
              class="btn btn-success btn-block mb-2"
              @click="
                moveAll(
                  users_selected.sectors_notselected.data,
                  'sectors',
                  'selectedSectors'
                )
              "
            >
              <span class="badge badge-light">{{
                users_selected.sectors_notselected.data.length
              }}</span>
              Mover todas >>
            </button>
            <div class="input-group mb-2">
              <input
                type="text"
                class="form-control"
                v-model="filter.sectors_search"
                placeholder="Procurar..."
                v-on:keyup.enter="getUsers()"
              />
              <div class="input-group-append">
                <button
                  class="btn btn-outline-secondary"
                  type="button"
                  @click="getUsers"
                >
                  <i class="fa fa-search"></i>
                </button>
              </div>
            </div>
            <ul class="list-group entity-filter-selection">
              <li
                class="list-group-item"
                v-for="sector in users_selected.sectors_notselected.data"
                :key="sector.id"
                @click="itemSelected(sector.id, 'sectors', 'selected')"
              >
                {{ sector.name }}
              </li>
            </ul>
            <paginate
              @click.native="getUsers"
              v-model="pages['sectors_notselected']"
              :page-count="users_selected.sectors_notselected.last_page"
              :prev-text="'Anterior'"
              :next-text="'Próximo'"
              :container-class="'vue-pagination'"
            >
            </paginate>
          </div>
          <div class="col-md-6">
            <button
              class="btn btn-success btn-block mb-2"
              @click="removeAllFull('sectors')"
            >
              << Remover todas as páginas
            </button>
            <button
              class="btn btn-success btn-block mb-2"
              @click="removeAll('selectedSectors', 'sectors', 'sectors')"
            >
              << Mover todas
              <span class="badge badge-light">{{
                users_selected.sectors_selected.data.length
              }}</span>
            </button>
            <input
              type="text"
              placeholder="Procurar..."
              class="form-control mb-2"
              v-model="filter.sectors_selected_search"
              v-on:keyup.enter="getUsers()"
            />
            <ul class="list-group entity-filter-selection">
              <li
                class="list-group-item"
                v-for="selectedSector in users_selected.sectors_selected.data"
                :key="selectedSector.id"
                @click="
                  removeItemSelected(selectedSector.id, 'sectors', 'selected')
                "
              >
                {{ selectedSector.name }}
              </li>
            </ul>
            <paginate
              @click.native="getUsers"
              v-model="pages['sectors_selected']"
              :page-count="users_selected.sectors_selected.last_page"
              :prev-text="'Anterior'"
              :next-text="'Próximo'"
              :container-class="'vue-pagination'"
            >
            </paginate>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <hr class="mt-5" />
        <h5>
          <b>Passo 4:</b> Selecione os
          <b>Cargos</b>
        </h5>
        <div class="row">
          <div class="col-md-6">
            <button
              class="btn btn-success btn-block mb-2"
              @click="
                moveAll(
                  users_selected.roles_notselected_all,
                  'roles',
                  'selectedRoles'
                )
              "
            >
              <!-- <span class="badge badge-light">{{
                users_selected.companies_notselected.data.length
              }}</span> -->
              Mover todas as páginas >>
            </button>
            <button
              class="btn btn-success btn-block mb-2"
              @click="
                moveAll(
                  users_selected.roles_notselected.data,
                  'roles',
                  'selectedRoles'
                )
              "
            >
              <span class="badge badge-light">{{
                users_selected.roles_notselected.data.length
              }}</span>
              Mover todas >>
            </button>
            <div class="input-group mb-2">
              <input
                type="text"
                class="form-control"
                v-model="filter.roles_search"
                placeholder="Procurar..."
                v-on:keyup.enter="getUsers()"
              />
              <div class="input-group-append">
                <button
                  class="btn btn-outline-secondary"
                  type="button"
                  @click="getUsers"
                >
                  <i class="fa fa-search"></i>
                </button>
              </div>
            </div>
            <ul class="list-group entity-filter-selection">
              <li
                class="list-group-item"
                v-for="role in users_selected.roles_notselected.data"
                :key="role.id"
                @click="itemSelected(role.id, 'roles', 'selected')"
              >
                {{ role.name }}
              </li>
            </ul>
            <paginate
              @click.native="getUsers"
              v-model="pages['roles_notselected']"
              :page-count="users_selected.roles_notselected.last_page"
              :prev-text="'Anterior'"
              :next-text="'Próximo'"
              :container-class="'vue-pagination'"
            >
            </paginate>
          </div>
          <div class="col-md-6">
            <button
              class="btn btn-success btn-block mb-2"
              @click="removeAllFull('roles')"
            >
              << Remover todas as páginas
            </button>
            <button
              class="btn btn-success btn-block mb-2"
              @click="removeAll('selectedRoles', 'roles', 'roles')"
            >
              << Mover todas
              <span class="badge badge-light">{{
                users_selected.roles_selected.data.length
              }}</span>
            </button>
            <input
              type="text"
              placeholder="Procurar..."
              class="form-control mb-2"
              v-model="filter.roles_selected_search"
              v-on:keyup.enter="getUsers()"
            />
            <ul class="list-group entity-filter-selection">
              <li
                class="list-group-item"
                v-for="selectedRole in users_selected.roles_selected.data"
                :key="selectedRole.id"
                @click="
                  removeItemSelected(selectedRole.id, 'roles', 'selected')
                "
              >
                {{ selectedRole.name }}
              </li>
            </ul>
            <paginate
              @click.native="getUsers"
              v-model="pages['roles_selected']"
              :page-count="users_selected.roles_selected.last_page"
              :prev-text="'Anterior'"
              :next-text="'Próximo'"
              :container-class="'vue-pagination'"
            >
            </paginate>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <hr class="mt-5" />
        <h5>
          <b>Passo 5:</b> Selecione os
          <b>Usuários</b>
        </h5>
        <div class="row">
          <div class="col-md-6">
            <button
              class="btn btn-success btn-block mb-2"
              @click="
                moveAll(
                  users_selected.users_notselected_all,
                  'users',
                  'selectedUsers'
                )
              "
            >
              <!-- <span class="badge badge-light">{{
                users_selected.companies_notselected.data.length
              }}</span> -->
              Mover todas as páginas >>
            </button>
            <button
              class="btn btn-success btn-block mb-2"
              @click="
                moveAll(
                  users_selected.users_notselected.data,
                  'users',
                  'selectedUsers'
                )
              "
            >
              <span class="badge badge-light">{{
                users_selected.users_notselected.data.length
              }}</span>
              Mover todos >>
            </button>
            <!-- <input
              type="text"
              placeholder="Procurar..."
              class="form-control mb-2"
              v-model="filter.users_search"
              v-on:keyup.enter="getUsers()"
            /> -->
            <ul class="list-group entity-filter-selection">
              <li
                class="list-group-item"
                v-for="user in users_selected.users_notselected.data"
                :key="user.id"
                @click="itemSelected(user.id, 'users', 'selected')"
              >
                {{ user.name }}
              </li>
            </ul>
            <paginate
              @click.native="getUsers"
              v-model="pages['users_notselected']"
              :page-count="users_selected.users_notselected.last_page"
              :prev-text="'Anterior'"
              :next-text="'Próximo'"
              :container-class="'vue-pagination'"
            >
            </paginate>
          </div>
          <div class="col-md-6">
            <button
              class="btn btn-success btn-block mb-2"
              @click="removeAllFull('users')"
            >
              << Remover todas as páginas
            </button>
            <button
              class="btn btn-success btn-block mb-2"
              @click="removeAll('selectedUsers', 'users', 'users')"
            >
              << Mover todos
              <span class="badge badge-light">{{
                users_selected.users_selected.data.length
              }}</span>
            </button>
            <!-- <input
              type="text"
              placeholder="Procurar..."
              class="form-control mb-2"
              v-model="filter.users_selected_search"
              v-on:keyup.enter="getUsers()"
            /> -->
            <ul class="list-group entity-filter-selection">
              <li
                class="list-group-item"
                v-for="selectedUser in users_selected.users_selected.data"
                :key="selectedUser.id"
                @click="
                  removeItemSelected(selectedUser.id, 'users', 'selected')
                "
              >
                {{ selectedUser.name }}
              </li>
            </ul>
            <paginate
              @click.native="getUsers"
              v-model="pages['users_selected']"
              :page-count="users_selected.users_selected.last_page"
              :prev-text="'Anterior'"
              :next-text="'Próximo'"
              :container-class="'vue-pagination'"
            >
            </paginate>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { debounce } from "vue-debounce";
import { Pagination } from "vue-pagination-2";
export default {
  data() {
    return {
      options: {
        texts: {
          count: "Mostrando {from} de {to} até {count} de registros",
        },
      },
      selectedCompanies: [],
      filter: {
        companies: {
          selected: [],
        },
        branches: {
          selected: [],
        },
        sectors: {
          selected: [],
        },
        roles: {
          selected: [],
        },
        users: {
          selected: [],
        },
        companies_search: "",
        companies_selected_search: "",
        sectors_search: "",
        sectors__selected_search: "",
        branches_search: "",
        branches_selected_search: "",
        roles_search: "",
        roles_selected_search: "",
        users_search: "",
        users_selected_search: "",
      },
      selectedBranches: [],
      selectedSectors: [],
      selectedRoles: [],
      selectedUsers: [],
      companies_search: "",
      branches_search: "",
      sectors_search: "",
      roles_search: "",
      users_search: "",
      users_selected: "",
      companies_selected_search: "",
      branches_selected_search: "",
      sectors_selected_search: "",
      roles_selected_search: "",
      users_selected_search: "",

      companies: [],
      branches: [],
      sectors: [],
      roles: [],
      users: [],
      pages: {
        companies: 1,
        branches: 1,
        sectors: 1,
        roles: 1,
      },
    };
  },
  components: {
    Pagination,
  },
  props: ["selectedUsersTotal"],
  watch: {},
  computed: {},
  methods: {
    removeAll(data, prop, type) {
      if (prop == "companies") {
        this.filter.companies.selected.forEach((selectedCompany, index) => {
          this.filter.companies.selected.splice(selectedCompany.id);
        });
      }
      if (prop == "branches") {
        this.filter.branches.selected.forEach((selectedCompany, index) => {
          this.filter.branches.selected.splice(selectedCompany.id);
        });
      }
      if (prop == "sectors") {
        this.filter.sectors.selected.forEach((selectedCompany, index) => {
          this.filter.sectors.selected.splice(selectedCompany.id);
        });
      }
      if (prop == "roles") {
        this.filter.roles.selected.forEach((selectedCompany, index) => {
          this.filter.roles.selected.splice(selectedCompany.id);
        });
      }
      if (prop == "users") {
        this.filter.users.selected.forEach((selectedCompany, index) => {
          this.filter.users.selected.splice(selectedCompany.id);
        });
      }

      this.getUsers();
    },
    moveAll(data, prop, type) {
      if (prop == "companies") {
        data.forEach((selectedCompany, index) => {
          this.filter.companies.selected.push(selectedCompany.id);
        });
      }
      if (prop == "branches") {
        data.forEach((selectedCompany, index) => {
          this.filter.branches.selected.push(selectedCompany.id);
        });
      }
      if (prop == "sectors") {
        data.forEach((selectedCompany, index) => {
          this.filter.sectors.selected.push(selectedCompany.id);
        });
      }
      if (prop == "roles") {
        data.forEach((selectedCompany, index) => {
          this.filter.roles.selected.push(selectedCompany.id);
        });
      }
      if (prop == "users") {
        data.forEach((selectedCompany, index) => {
          this.filter.users.selected.push(selectedCompany.id);
        });
      }

      this.getUsers();
    },
    removeAllFull(which) {
      // this.$store.dispatch("changeLoader", true);
      this.filter[which].selected = [];
      this.getUsers();
    },
    moveAllFull(model, to) {
      const self = this;
      // self.$store.dispatch("changeLoader", true);
      axios
        .post(
          this.$store.getters.api +
            "move-all-full" +
            "/?companynotselected_page=" +
            this.pages["companies_notselected"] +
            "&companyselected_page=" +
            this.pages["companies_selected"] +
            "&branchnotselected_page=" +
            this.pages["branches_notselected"] +
            "&branchselected_page=" +
            this.pages["branches_selected"] +
            "&sectornotselected_page=" +
            this.pages["sectors_notselected"] +
            "&sectorselected_page=" +
            this.pages["sectors_selected"] +
            "&rolenotselected_page=" +
            this.pages["roles_notselected"] +
            "&roleselected_page=" +
            this.pages["roles_selected"] +
            "&usernotselected_page=" +
            this.pages["users_notselected"] +
            "&userselected_page=" +
            this.pages["users_notselected"] +
            "&model=" +
            model,
          this.filter
        )
        .then((response) => {
          response.data.forEach((id) => {
            self.filter[to].selected.push(id);
          });
          self.getUsers();
        })
        .catch((error) => {
          // self.$store.dispatch("changeLoader", false);
          self.$message("Erro", error.response.data || error, "error");
        });
    },
    itemSelected(id, prop, type) {
      if (prop == "companies") {
        if (type == "selected") {
          this.filter.companies.selected.push(id);
        }
      }
      if (prop == "branches") {
        if (type == "selected") {
          this.filter.branches.selected.push(id);
        }
      }
      if (prop == "sectors") {
        if (type == "selected") {
          this.filter.sectors.selected.push(id);
        }
      }
      if (prop == "roles") {
        if (type == "selected") {
          this.filter.roles.selected.push(id);
        }
      }
      if (prop == "users") {
        if (type == "selected") {
          this.filter.users.selected.push(id);
        }
      }
      this.getUsers();
    },
    removeItemSelected(id, prop, type) {
      if (prop == "companies") {
        if (type == "selected") {
          let foundIndex = this.filter.companies.selected.findIndex(
            (item) => item == id
          );
          if (foundIndex !== null) {
            this.filter.companies.selected.splice(foundIndex, 1);
          }
        }
      }
      if (prop == "branches") {
        if (type == "selected") {
          let foundIndex = this.filter.branches.selected.findIndex(
            (item) => item == id
          );
          if (foundIndex !== null) {
            this.filter.branches.selected.splice(foundIndex, 1);
          }
        }
      }
      if (prop == "sectors") {
        if (type == "selected") {
          let foundIndex = this.filter.sectors.selected.findIndex(
            (item) => item == id
          );
          if (foundIndex !== null) {
            this.filter.sectors.selected.splice(foundIndex, 1);
          }
        }
      }
      if (prop == "roles") {
        if (type == "selected") {
          let foundIndex = this.filter.roles.selected.findIndex(
            (item) => item == id
          );
          if (foundIndex !== null) {
            this.filter.roles.selected.splice(foundIndex, 1);
          }
        }
      }
      if (prop == "users") {
        if (type == "selected") {
          let foundIndex = this.filter.users.selected.findIndex(
            (item) => item == id
          );
          if (foundIndex !== null) {
            this.filter.users.selected.splice(foundIndex, 1);
          }
        }
      }
      this.getUsers();
    },
    getUsers() {
      const self = this;
      // self.$store.dispatch("changeLoader", true);
      axios
        .post(
          self.$store.getters.api +
            "users-selected" +
            "/?companynotselected_page=" +
            self.pages["companies_notselected"] +
            "&companyselected_page=" +
            self.pages["companies_selected"] +
            "&branchnotselected_page=" +
            self.pages["branches_notselected"] +
            "&branchselected_page=" +
            self.pages["branches_selected"] +
            "&sectornotselected_page=" +
            self.pages["sectors_notselected"] +
            "&sectorselected_page=" +
            self.pages["sectors_selected"] +
            "&rolenotselected_page=" +
            self.pages["roles_notselected"] +
            "&roleselected_page=" +
            self.pages["roles_selected"] +
            "&usernotselected_page=" +
            self.pages["users_notselected"] +
            "&userselected_page=" +
            self.pages["users_notselected"],
          self.filter
        )
        .then((response) => {
          self.users_selected = response.data;
          self.getSelectedUsersTotal();
          // self.$store.dispatch("changeLoader", false);
        })
        .catch((error) => {
          // self.$store.dispatch("changeLoader", false);
          console.log(error);
        });
    },
    getSelectedUsersTotal() {
      const self = this;
      self.$emit(
        "selectedUsersTotalChanged",
        this.users_selected.users_selected_false
      );
    },
    getMoveAllUsers() {
      this.moveAll(
        this.users_selected.users_notselected_all,
        'users',
        'selectedUsers'
      )
      this.getSelectedUsersTotal();
    },
  },
  mounted: function () {
    const self = this;
    this.getUsers();
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Utils/UsersSelection.vue